import React from 'react';
import { EnterpriseDashboard } from '@/components/enterprise/EnterpriseDashboard';

const EnterprisePage: React.FC = () => {
  return <EnterpriseDashboard />;
};

export default EnterprisePage;